import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "268",
  "slug": "spot-brazil-from-satellite-imagery",
  "title": "How to Recognise Brazil in Satellite Images",
  "excerpt": "The Amazon crosses northern Brazil through an extensive lowland forest region.",
  "date": "2026-05-18",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/brazil.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Amazon crosses northern Brazil through an extensive lowland forest region. South and east of that basin, the landscape rises into the Brazilian Highlands. In detailed imagery, agricultural clearings and roads may break up otherwise wooded land; their arrangement can help describe land use but does not establish a national border."
    },
    {
      "type": "heading",
      "text": "The Amazon and the central plateau"
    },
    {
      "type": "paragraph",
      "text": "Locate the Amazon mouth and trace the river inland. Compare a section near the main channel with the higher ground to the south."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The Amazon forest extends into neighbouring countries. Dense green canopy alone cannot separate Brazil from Peru or Colombia. Look for a recognisable river junction or a wider regional position before making that distinction."
    }
  ],
  "imageAlt": "Brazil regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
